module.exports = __webpack_public_path__ + "static/img/erpang.2261aea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/erpang.jpg
// module id = LZsM
// module chunks = 2 6